<template>
  <div class="content-wrapper">
    <h2 class="mb-5">Merchants</h2>
    <vx-card>
      <ag-grid-vue
        rowSelection="multiple"
        colResizeDefault="shift"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :rowData="items"
      ></ag-grid-vue>
    </vx-card>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import Service from "../../../services";

export default {
  components: {
    AgGridVue
  },
  data: () => ({
    columnDefs: [
      { headerName: "ID", field: "merchant_id" },
      { headerName: "Name", field: "name" },
      { headerName: "Phone", field: "phone" },
      { headerName: "Email", field: "email" }
    ],
    items: []
  }),
  created() {
    Service.Merchant.gets().then(res => {
      this.items = res.data.data;
    });
  },
  methods: {}
};
</script>